import { StatusBadge, type StatusTone } from "@/components/status-badge";

export type AccountStatusCode = "Open" | "Overdue" | "FinalNotice" | "Closed" | "Hold" | "CreditHold";

const tone: Record<AccountStatusCode, StatusTone> = {
  Open:        "success",
  Overdue:     "warning",
  FinalNotice: "danger",
  Closed:      "muted",
  Hold:        "info",
  CreditHold:  "info",
};

const label: Record<AccountStatusCode, string> = {
  Open:        "Open",
  Overdue:     "Overdue",
  FinalNotice: "Final notice",
  Closed:      "Closed",
  Hold:        "On hold",
  CreditHold:  "Credit hold",
};

export function AccountStatusBadge({ code }: { code: AccountStatusCode }) {
  return <StatusBadge tone={tone[code]}>{label[code]}</StatusBadge>;
}
